import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_DELIVERY_POINT_ROUTE_LOADING = 'GET_DELIVERY_POINT_ROUTE_LOADING';
export const GET_DELIVERY_POINT_ROUTE_SUCCESS = 'GET_DELIVERY_POINT_ROUTE_SUCCESS';
export const GET_DELIVERY_POINT_ROUTE_REJECT = 'GET_DELIVERY_POINT_ROUTE_REJECT';

//* ACTIONS ------------------------------------------------
export const getDeliveryPointRouteLoading = () => ({ type: GET_DELIVERY_POINT_ROUTE_LOADING });
export const getDeliveryPointRouteSuccess = (payload) => ({ type: GET_DELIVERY_POINT_ROUTE_SUCCESS, payload });
export const getDeliveryPointRouteReject = (payload) => ({ type: GET_DELIVERY_POINT_ROUTE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getDeliveryPointRouteRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.GET,
        data,
    }, getState);
    return request(`/Route/web/GetRouteDeliveryPoint/${data}`, options);
};

